import React from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

import LookListContentHeaderRightSide from "./lookListContentHeaderRightSide";
import {getCartItemsCount} from "../grohe/groheNavigation/groheFunctions";
import {changeAllCartItems} from "../../../actions/shoppingCartFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";

const LookListContentHeader = (props) => {

  const {cartItems, onBackClick, visualizersLoadedLength, intl, changeAllCartItems, fabricatorSettings,
    isPhoneNumberValidated} = props;

  let itemsToCount = getCartItemsCount(cartItems, intl);
  const selectAllChecked = cartItems.every(cItem => cItem.relatedProductParent || !cItem.isRemoved);

  const selectAllItemsClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookListSelectAllItems + (selectAllChecked ? "uncheck" : "check"));
    const newCartItems = [...cartItems.map(cItem => {
      cItem.isRemoved = selectAllChecked;
      return cItem
    })];
    changeAllCartItems(newCartItems);
  }

  const getQuote = fabricatorSettings.enableQuote && !isPhoneNumberValidated;

  return (
    <header className="ll-header">
      <div className="ll-header__left">
        <h1 className="ll-title">
          <FormattedMessage id={getQuote ? "look.list.header.title.getQuote" : "look.list.header.title"}/>
          {visualizersLoadedLength && !getQuote ? ` (${itemsToCount})` : null}
        </h1>
        <h2 className="ll-sub-title">
          <FormattedMessage id={getQuote ? "look.list.header.subTitle.getQuote" : "look.list.header.subTitle"}/>
        </h2>
        <FormControlLabel
          className="ll-text"
          label={intl.formatMessage({id: "look.list.header.selectAllItemsText"})}
          control={<Checkbox checked={selectAllChecked} onChange={selectAllItemsClick} />}
        />
        {/*<p className="ll-text2">*/}
        {/*  {itemsToCount} <FormattedMessage id="look.list.header.items"/>*/}
        {/*</p>*/}
      </div>
      <LookListContentHeaderRightSide onBackClick={onBackClick}/>
    </header>
  )
};

LookListContentHeader.propTypes = {
  onBackClick: PropTypes.func.isRequired
}

const mapStateToProps = (store) => {
  const {cartItems} = store.cartState;
  const {visualizersLoaded} = store.serverState;
  const {settings} = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState;

  return {
    cartItems,
    visualizersLoadedLength: visualizersLoaded.length,
    fabricatorSettings: settings,
    isPhoneNumberValidated,
  }
};

const mapDispatchToProps = {
  changeAllCartItems
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookListContentHeader)
)
